import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {Badge} from '../model/model';
import {BadgeRepository} from '../repositories/badge.repository';

@Injectable()
export class BadgeService {

  constructor(private badgeRepository: BadgeRepository) { }

  public getBadges(): Observable<Array<Badge>> {
    return this.badgeRepository.getBadges();
  }

  public calculateNewBadges(): Observable<number> {
    return this.badgeRepository.calculateNewBadges();
  }

}
